import React from "react";
import { Link } from "react-router-dom";
import {
  useAccount,
  useConnect,
  useDisconnect,
 } from 'wagmi';
// We'll use ethers to interact with the Ethereum network and our contract
import { ethers, provider, getDefaultProvider } from "ethers";
import {
  ChainId,
  Token,
  Trade,
  Fetcher,
  Route,
  Pair,
  TradeType,
  TokenAmount,
  WETH,
} from "@uniswap/sdk";

// We import the contract's artifacts and address here,
// as we are going to be using them with ethers
import QuantumToken from "../contracts/abis/Quantum.json";
import StakingToken from "../contracts/abis/Staking.json";
import StakingToken2 from "../contracts/abis/Staking2.json";
import Proxy from "../contracts/abis/Proxy.json";
import LPToken from "../contracts/abis/Uniswap.json";
import UniswapV2 from "../contracts/abis/UniswapV2.json";
import Router from "../contracts/abis/Router.json";
import wETH from "../contracts/abis/wETH.json";
import contractAddress from "../contracts/contract-address.json";

/* 
All the logic of this dapp is contained in the Dapp component. These other components are just presentational ones: they don't have any logic. They just render HTML. 
*/
import { NoWalletDetected } from "./dapp/NoWalletDetected";
import { ConnectWallet } from "./dapp/ConnectWallet";
import { Loading } from "./dapp/Loading";
import { ClaimReward } from "./dapp/ClaimReward";
import { ClaimRewardLP } from "./dapp/ClaimRewardLP";
import { NotEligible } from "./dapp/NotEligible";
import { Approve } from "./dapp/Approve";
import { Approved } from "./dapp/Approved";
import { AddLiquidity } from "./dapp/AddLiquidity";
import { ApproveQTE } from "./dapp/ApproveQTEProxy";
import { ApprovedQTE } from "./dapp/ApprovedQTE";
import { ApproveWETH } from "./dapp/ApproveWETHProxy";
import { Deposit } from "./dapp/Deposit";
import { DepositQTE } from "./dapp/DepositQTE";
import { Withdrawal } from "./dapp/Withdrawal";
import { WithdrawalQTE } from "./dapp/WithdrawalQTE";
import { TransactionErrorMessage } from "./dapp/TransactionErrorMessage";
import { WaitingForTransactionMessage } from "./dapp/WaitingForTransactionMessage";

//Import media
// import Farming from "../components/Farming";
import Video from "../components/Video";
import Bg2 from "../videos/bg-video-dashboard.mp4";
import Bg3 from "../images/bg-dashboard-new.png";
import thumb1 from "../images/thmb-qte.svg";
// import PureCounter from "@srexi/purecounterjs";
import $ from "jquery";
import smallLogo from "../images/logo-quantum-small-v2.svg";

// This is the Hardhat Network id that we set in our hardhat.config.js.
// Here's a list of network ids https://docs.metamask.io/guide/ethereum-provider.html#properties
// to use when deploying to other networks.
const HARDHAT_NETWORK_ID = "1";

// This is an error code that indicates that the user canceled a transaction
const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

// This component is in charge of doing these things:
//   1. It connects to the user's wallet
//   2. Initializes ethers and the Token contract
//   3. Polls the user balance to keep it updated.
//   4. Transfers tokens by sending transactions
//   5. Renders the whole application
//
// Note that (3) and (4) are specific of this sample application, but they show
// you how to keep your Dapp and contract's state in sync,  and how to send a
// transaction.
export class Dapp extends React.Component {
  constructor(props) {
    super(props);

    // We store multiple things in Dapp's state.
    // You don't need to follow this pattern, but it's an useful example.
    this.initialState = {
      // The info of the token (i.e. It's Name and symbol)
      tokenData: undefined,
      // The user's address and balance
      // selectedAddress: undefined,
      balance: undefined,
      // The ID about transactions being sent, and any possible error with them
      txBeingSent: undefined,
      tx: undefined,
      transactionError: undefined,
      networkError: undefined,
      balanceOf: undefined,
      //boolean of whether wallet is eligible
      isEligible: undefined,
      LPtoken: undefined,
      //how much has been deposited for farming
      lpDeposited: undefined,
      //rewards to be claimed
      rewards: undefined,
      rewardsLP: undefined,
      //rewards earned to date
      earned: undefined,
      lpTokenBalance: undefined,
      tokenToEth: undefined,
      ethToToken: undefined,
      balanceInEth: undefined,
      liqTokenA: undefined,
      liqTokenB: undefined,
      approvedQTEforProxy: undefined,
      approvedWETHforProxy: undefined,
      approvedQTEforStaking: undefined,
      rewardPerToken: undefined,
      rewardPerTokenStored: undefined,
      rewardRate: undefined,
      userRewardPerTokenPaid: undefined,
      lpRewardsEarned: undefined,
      lpTotalSupply: undefined,
      shareOfPool: undefined,
      stakedQTE: undefined,
      stakingRewards: undefined,

    };
    this.state = this.initialState;
  }

  render() {
    // Ethereum wallets inject the window.ethereum object. If it hasn't been
    // injected, we instruct the user to install MetaMask.
    if (window.ethereum === undefined) {
      return <NoWalletDetected />;
    }
    function decimalRound(bal, decimals) {
      if (!decimals) decimals = 2;
      return Number.parseFloat(bal).toFixed(decimals);
    }

    function truncateNumber(bal) {
      return bal.toFixed(2);
    }

    // The next thing we need to do, is to ask the user to connect their wallet.
    // When the wallet gets connected, we are going to save the users's address
    // in the component's state. So, if it hasn't been saved yet, we have
    // to show the ConnectWallet component.
    //
    // Note that we pass it a callback that is going to be called when the user
    // clicks a button. This callback just calls the _connectWallet method.
    if (!this.state.selectedAddress) {
      return (
        <ConnectWallet
          connectWallet={() => this._connectWallet()}
          networkError={this.state.networkError}
          dismiss={() => this._dismissNetworkError()}
        />
      );
    }

    // If the token data or the user's balance hasn't loaded yet, we show
    // a loading component.
    if (!this.state.tokenData || !this.state.balance) {
      return <Loading />;
    }

    // If everything is loaded, we render the application.
    return (
      <>
        <header className="header-section">
          <div className="container">
            <div className="header-holder">
              <div className="header-primary d-flex flex-wrap justify-content-between align-items-center">
                <div className="brand-logo d-none d-lg-inline-block">
                  <div className="logo">
                    <Link to="/">
                      <img
                        src={smallLogo}
                        alt="logo"
                        width={100}
                        height={100}
                      />
                    </Link>
                  </div>
                </div>
                <div className="header-wrapper justify-content-lg-end">
                  <div className="mobile-logo d-lg-none">
                    <a href="index.html">
                      <img
                        src={smallLogo}
                        alt="logo"
                        width={100}
                        height={100}
                      />
                    </a>
                  </div>

                  <div className="menu-area">
                    <ul className="menu">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/arcade">Arcade</Link>
                      </li>
                    </ul>

                    <div className="header-bar d-lg-none">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        {/* // Dashboard Header */}
        <section className="banner padding-top bg-dashboard" id="dashboard">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6 mt-5 text-left">
                <div
                  className="banner__content text-left"
                  data-aos="zoom-in"
                  data-aos-duration="900"
                >
                  {/* <h1 className="title-dashboard">Dashboard</h1> */}
                 
                  <div className="dashboard-widget-block">
                    <h3 className="pb-2">Welcome back!</h3>
                    <h5 className="pb-2">
                      <span className="blue-h1">
                          {decimalRound(
                            ethers.utils.formatUnits(this.state.balance, 18)
                          )}{" "}
                          
                      </span>
                      QTE
                    </h5>
                    <h5>
                    <span className="blue-headline">
                      {" "}{decimalRound(
                          ethers.utils.formatUnits(this.state.rewardRate, 18)
                        )}{" "}
                        QTE{" "}
                      </span>
                      <span className="dash-bal-headline">Per Token Yield </span>
                    </h5>
                    <p>Staking ends on Thu Oct 12 2023 15:49:11 GMT+0000</p>
                  </div>
                  {this.state.stakedQTE.gt(0) &&
                  <div className="dashboard-widget-block mt-2">
                    <h3 className="pb-2">Staked Tokens</h3>
                    
                   
                    <h5 className="pb-2">
                      <span className="blue-h1">
                      {decimalRound(
                                ethers.utils.formatUnits(
                                  this.state.stakedQTE,
                                  18
                                )
                              )}
                      </span>{" "}
                      QTE
                    </h5>
                </div>
 }

                  {this.state.lpDeposited.gt(0) &&
                  <div className="dashboard-widget-block mt-2">
                    <h3 className="pb-2">Liquidity Farming</h3>
                    
                   
                    <h5 className="pb-2">
                      <span className="blue-h1">
                      {decimalRound(
                                ethers.utils.formatUnits(
                                  this.state.lpDeposited,
                                  18
                                )
                              )}
                      </span>{" "}
                      Deposited
                    </h5>
                    <h5>
                      <span className="blue-headline">
                      {
                        truncateNumber(
                        ethers.utils.formatUnits(
                          this.state.lpDeposited,18)/ethers.utils.formatUnits(
                            this.state.lpTotalSupply,18)*100)
                      }
                      {"% "}
                      </span>
                      <span className="dash-bal-headline">
                      Share of LP</span>
                    </h5>
                  </div>
  }
                  {/* <p>
                    <span className="blue-headline">NOTE:</span> Transfers are
                    taxed at 50% to prevent people trying to game the system.
                  </p> */}
                </div>

              </div>
              <div className="col-12 col-lg-5 offset-lg-1  text-center stacking__project-item padding-top my-5 dashboard-widget" data-aos="zoom-in"
                  data-aos-duration="900">
                <h2 className="title-dashboard-rewards pb-2">Reward Zone</h2>
                <h4 className="pb-2">Staking Rewards</h4>
                <h3 className="blue-headline py-2">
                {decimalRound(
                        ethers.utils.formatUnits(this.state.stakingRewards, 18)
                      )}{" "}
                      QTE
                </h3>
                {this.state.stakingRewards.gt(0) && (
                  <ClaimReward
                    claimReward={() =>
                      this._claimReward(this.state.selectedAddress)
                    }
                    userRewards={this.state.userRewards}
                  />
                )}

                <p className="py-3"><hr /></p>
                <h4 className="pb-2">LP Farming Rewards</h4>
                <h3 className="blue-headline py-2">
                                  {" "}
                                  {decimalRound(
                                    ethers.utils.formatUnits(
                                      this.state.rewardsLP,
                                      18
                                    )
                                  )}{" "}
                                  QTE
                                </h3>
                {this.state.lpDeposited.gt(0) && (
                                  <ClaimRewardLP
                                    claimRewardLP={() =>
                                      this._claimRewardLP(
                                        this.state.selectedAddress
                                      )
                                    }
                                  />
                                )}
              </div>
            </div>
          </div>
        </section>
        {/* // Error Messaging */}
        <section className="fixed-top container-fluid g-0" id="alerts">
          <div className="container-fluid g-0">
            <div className="row">
              <div className="col-12">
                {/*
Sending a transaction isn't an immediate action. You have to wait
for it to be mined.
If we are waiting for one, we show a message here.
*/}
                {this.state.txBeingSent && (
                  <WaitingForTransactionMessage
                    txHash={this.state.txBeingSent}
                  />
                )}

                {/*
Sending a transaction can fail in multiple ways.
If that happened, we show a message here.
*/}
                {this.state.transactionError && (
                  <TransactionErrorMessage
                    message={this._getRpcErrorMessage(
                      this.state.transactionError
                    )}
                    dismiss={() => this._dismissTransactionError()}
                  />
                )}
              </div>
            </div>
          </div>
        </section>

        {/* staking section */}
        <div className="farming padding-bottom">
          <div className="container">
            <div className="stacking__title">
              <h3>Staking Rewards</h3>
            </div>
            <div className="farming__wrapper">
              <div className="row g-5">
                {/* //just added */}
                <div className="col-12">
                  <div className="farming__item">

                    <div
                      className="farming__item-body farming-show"
                      id="farming__content3"
                    >
                      <div className="farming__item-content">
                        <div className="row g-5">
                          <div className="col-lg-4 col-md-6">
                            <div className="farming__deposit">
                              <div className="farming__deposit-field">
                                
                                <h6 className="form-label">
                                  Approve QTE Token
                                </h6>
                                <p className="blue-headline">
                                  Approve the QTE token for the new staking contract; this will allow your wallet to interact with our staking functionality.
                                </p>
              


                                {this.state.stakedQTE.eq(0) && (
                                  <ApproveQTE
                                      approveQTE={() =>
                                        this._approveQTEforStaking()}
                                
                                    />
                                    )}

                                    {this.state.stakedQTE.gt(0) && (
                                    <ApprovedQTE
                                      approveQTE={() => this._approveQTEforStaking()}
                                    />
                                  )}
                                <div className="mb-3">
                                
                                </div>
                                <div className="text-end"></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                          <div className="farming__withdraw text-left">
                              <div className="farming__claim-title">
                                <h6 className="pb-2">
                                  Stake Your Tokens
                                </h6>
                                <DepositQTE
                                    depositQTEToken={(amount) =>
                                      this._depositQTEToken(amount)
                                    }
                                    max={ethers.utils.formatUnits(
                                      this.state.balance,
                                      18
                                    )}
                                  />
                                
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="farming__withdraw text-left">
                              <div className="farming__claim-title">
                                <h6 className="pb-2">Unstake Tokens</h6>
                                <WithdrawalQTE
                                    withdrawQTEToken={(amount) =>
                                      this._withdrawQTEToken(amount)
                                    }
                                    max={ethers.utils.formatUnits(
                                      this.state.stakedQTE,
                                      18
                                    )}
                                  />
                                  
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         {/* farming section */}
         <div className="farming padding-bottom">
          <div className="container">
            <div className="stacking__title">
              <h3>Liquidity Farming</h3>
            </div>
            <div className="farming__wrapper">
              <div className="row g-5">
                {/* //just added */}
                <div className="col-12">
                  <div className="farming__item">
                    <div className="farming__item-header">
                      <div className="farming__thumb">
                        <img src={thumb1} alt="QTE/ETH" />
                      </div>
                      <div className="farming__content">
                        <div className="farming__content-title">
                          <h4>Quantum Energy LP Farming</h4>
                          <p>QTE / ETH</p>
                        </div>

                        <p>
                          Add liquidity to our Uniswap LP and get QTE rewards
                          when you deposit your LP tokens.
                        </p>
                        <ul className="farming__list">
                          <li className="farming__list-item">
                            <h5>
                              {decimalRound(
                                ethers.utils.formatUnits(
                                  this.state.lpDeposited,
                                  18
                                )
                              )}
                              LP
                            </h5>
                            <p>Deposited</p>
                          </li>
                          <li className="farming__list-item">
                            <h5>
                              {" "}
                              {decimalRound(
                                ethers.utils.formatUnits(
                                  this.state.rewardsLP,
                                  18
                                )
                              )}{" "}
                              QTE
                            </h5>
                            <p>Earned from LP</p>
                          </li>
                          <li className="farming__list-item">
                          </li>
                          <li className="farming__list-item"></li>
                        </ul>
                      </div>
                    </div>
                    <div
                      className="farming__item-body farming-show"
                      id="farming__content2"
                    >
                       <div className="farming__item-content">
                        <div className="row g-5">
                          <div className="col-lg-4 col-md-6">
                            <div className="farming__deposit">
                              <div className="farming__deposit-field">
                                <h6>How to Start Earning</h6>
                                <ol className="list-ordered">
                                  <li>Add liquidity to our Uniswap LP.</li>
                                  <li>
                                    Approve Uniswap/Quantum Energy contract to
                                    allow LP token deposits.
                                  </li>
                                  <li>
                                    Deposit LP tokens. Earn twice the rewards
                                    compared to regular Airdrop Rewards.
                                  </li>
                                </ol>
                              </div>
                              <div className="text-end"></div>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div className="farming__withdraw text-center">
                              <div className="farming__withdraw-field">
                                <h6 className="form-label pb-1">
                                  1. Add to Uniswap Liquidity
                                </h6>
                                <div className="mb-3">
                                  <a
                                    href="https://app.uniswap.org/#/add/v2/ETH/0xe89A194D366A3f18B06Ced6474DC7dAba66EFa83"
                                    className="default-btn"
                                    target="_blank"
                                    alt="Add Liquidity"
                                  >
                                    Add Liquidity
                                  </a>
                                </div>
                                <div className="text-end"></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="farming__withdraw text-center">
                              <div className="farming__claim-title">
                                <h6 className="form-label pb-1">
                                 2. Approve Contract
                                </h6>
                                <div className="mb-0">
                                  {this.state.lpDeposited.eq(0) && (
                                    <Approve
                                      approveToken={() => this._approveToken()}
                                    />
                                  )}
                                  {/* {this.state.rewardsLP.eq(0) && (
                                    <Approve
                                      approveToken={() => this._approveToken()}
                                    />
                                  )} */}
                                  {this.state.lpDeposited.gt(0) && (
                                    <Approved
                                      approveToken={() => this._approveToken()}
                                    />
                                  )}
                                </div>
                                <div className="text-end"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="farming__item-body farming-show"
                      id="farming__content3"
                    >
                      <div className="farming__item-content">
                        <div className="row g-5">
                          <div className="col-lg-4 col-md-6">
                            <div className="farming__deposit">
                              <div className="farming__deposit-field">
                                <h6 className="form-label">
                                  Deposit LP Tokens
                                </h6>
                                {/* <p className="blue-headline">
                                  OFFLINE FOR UPDATES
                                </p> */}
                                <div className="mb-3">
                                  <Deposit
                                    depositToken={(amount) =>
                                      this._depositToken(amount)
                                    }
                                    max={ethers.utils.formatUnits(
                                      this.state.lpTokenBalance,
                                      18
                                    )}
                                  />
                                </div>
                                <div className="text-end"></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="farming__withdraw">
                              <div className="farming__withdraw-field">
                                <h6 className="form-label">Withdraw</h6>
                                {/* <p className="blue-headline">
                                  OFFLINE FOR UPDATES
                                </p> */}
                                <div className="mb-3">
                                  <Withdrawal
                                    withdrawToken={(amount) =>
                                      this._withdrawToken(amount)
                                    }
                                    max={ethers.utils.formatUnits(
                                      this.state.lpDeposited,
                                      18
                                    )}
                                  />
                                </div>
                                <div className="text-end"></div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-6">
                            <div className="farming__withdraw text-center">
                              <div className="farming__claim-title">
                                <h6 className="pb-2">Pending LP Rewards</h6>
                                <h4 className="pb-2">
                                  {" "}
                                  {decimalRound(
                                    ethers.utils.formatUnits(
                                      this.state.rewardsLP,
                                      18
                                    )
                                  )}{" "}
                                  QTE
                                </h4>
                              </div>
                              <div className="text-center">
                                {this.state.lpDeposited.gt(0) && (
                                  <ClaimRewardLP
                                    claimRewardLP={() =>
                                      this._claimRewardLP(
                                        this.state.selectedAddress
                                      )
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  componentWillUnmount() {
    // We poll the user's balance, so we have to stop doing that when Dapp
    // gets unmounted
    this._stopPollingData();
  }

  async _connectWallet() {
    // This method is run when the user clicks the Connect. It connects the
    // dapp to the user's wallet, and initializes it.

    // To connect to the user's wallet, we have to run this method.
    // It returns a promise that will resolve to the user's address.
    const [selectedAddress] = await window.ethereum.request({
      method: "eth_requestAccounts",
    });

    // Once we have the address, we can initialize the application.

    // First we check the network
    if (!this._checkNetwork()) {
      return;
    }

    this._initialize(selectedAddress);

    // We reinitialize it whenever the user changes their account.
    window.ethereum.on("accountsChanged", ([newAddress]) => {
      this._stopPollingData();
      // `accountsChanged` event can be triggered with an undefined newAddress.
      // This happens when the user removes the Dapp from the "Connected
      // list of sites allowed access to your addresses" (Metamask > Settings > Connections)
      // To avoid errors, we reset the dapp state
      if (newAddress === undefined) {
        return this._resetState();
      }

      this._initialize(newAddress);
    });

    // We reset the dapp state if the network is changed
    window.ethereum.on("chainChanged", ([networkId]) => {
      this._stopPollingData();
      this._resetState();
    });
  }

  _initialize(userAddress) {
    // This method initializes the dapp
    // We first store the user's address in the state
    this.setState({
      selectedAddress: userAddress,
    });

    // Then, we initialize ethers, fetch the token's data, and start polling for the user's balance.

    /* Fetching the token data and the user's balance are specific to this sample project, but you can reuse the same initialization pattern. */
    this._initializeEthers();
    this._getTokenData();
    this._startPollingData();
  }

  async _initializeEthers() {
    // We first initialize ethers by creating a provider using window.ethereum
    this._provider = new ethers.providers.Web3Provider(window.ethereum);

    /* Then, we initialize the contract using that provider and the token's artifact. You can do this same thing with your contracts. */

    this._token = new ethers.Contract(
      contractAddress.Token,
      QuantumToken.abi,
      this._provider.getSigner(0)
    );

    //Initialize Quantum Staking contract
    this._farming = new ethers.Contract(
      contractAddress.Staking,
      StakingToken.abi,
      this._provider.getSigner(0)
    );
    this._lpToken = new ethers.Contract(
      contractAddress.LPtoken,
      LPToken.abi,
      this._provider.getSigner(0)
    );
    this._proxy = new ethers.Contract(
      contractAddress.Proxy,
      Proxy.abi,
      this._provider.getSigner(0)
    );
    this._router = new ethers.Contract(
      contractAddress.Router,
      Router.abi,
      this._provider.getSigner(0)
    );
    this._uniswapV2 = new ethers.Contract(
      contractAddress.UniswapV2,
      UniswapV2.abi,
      this._provider.getSigner(0)
    );
    this._weth = new ethers.Contract(
      contractAddress.wETH,
      wETH.abi,
      this._provider.getSigner(0)
    );
    //Initialize Quantum Staking contract
    this._staking = new ethers.Contract(
      contractAddress.Staking2,
      StakingToken2.abi,
      this._provider.getSigner(0)
    );

    // const network = await this._provider.getNetwork();
    // console.log(network);
  }

  // The next two methods are needed to start and stop polling data. While
  // the data being polled here is specific to this example, you can use this
  // pattern to read any data from your contracts.
  //
  // Note that if you don't need it to update in near real time, you probably
  // don't need to poll it. If that's the case, you can just fetch it when you
  // initialize the app, as we do with the token data.
  _startPollingData() {
    this._pollDataInterval = setInterval(() => this._updateBalance(), 15000);
    this._pollDataInterval2 = setInterval(() => this._getPrice(), 15000);

    // We run it once immediately so we don't have to wait for it
    // this._updateBalance();
    // this._earnedRewards();
    this._getPrice();
    this._getEthBalance();
  }

  _stopPollingData() {
    clearInterval(this._pollDataInterval);
    clearInterval(this._pollDataInterval2);
    this._pollDataInterval = undefined;
    this._pollDataInterval2 = undefined;
  }

  async _getEthBalance() {
    await this._provider
      .getBalance("0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2")
      .then((bal) => {
        // convert a currency unit from wei to ether
        const balanceInEth = ethers.utils.formatEther(bal);
        // console.log(`balance: ${balanceInEth} ETH`);
        this.setState({
          balanceInEth: balanceInEth,
        });
      });
  }

   _getShareOfPool() {
    const lpDeposited = this.state.lpDeposited;
    const lpTotalSupply = this.state.lpTotalSupply;
    const shareOfPool = lpDeposited / lpTotalSupply;
    console.log("share of pool",shareOfPool);
    this.setState({
      shareOfPool: shareOfPool,
    });
  }
  /* The next two methods just read from the contract and store the results in the component state. */

  async _getTokenData() {
    const name = await this._token.name();
    const symbol = await this._token.symbol();
    const LPtoken = await this._token.LPtoken();
    const decimals = await this._token.decimals();
    const totalSupply = await this._token.totalSupply();
    const lpTotalSupply = await this._farming.totalSupply();

    this.setState({
      tokenData: { name, symbol },
      LPtoken,
      decimals,
      totalSupply,
      lpTotalSupply,
    });
  }
  async _getPrice() {
    const network = "homestead";
    const provider = new ethers.providers.InfuraProvider(
      network,
      "6ceac41b517349e89d200213e00734ff"
    );
    const url = "https://mainnet.infura.io/v3/6ceac41b517349e89d200213e00734ff";
    const customHttpProvider = new ethers.providers.JsonRpcProvider(url);

    const chainId = ChainId.MAINNET;
    const tokenAddress = "0xe89A194D366A3f18B06Ced6474DC7dAba66EFa83";
    const token = await Fetcher.fetchTokenData(
      chainId,
      tokenAddress,
      customHttpProvider
    );
    token.symbol = "QTE";
    const pair = await Fetcher.fetchPairData(token, WETH[chainId], provider);
    const route = new Route([pair], WETH[chainId]);
    const trade = new Trade(
      route,
      new TokenAmount(WETH[token.chainId], "1000000000000000000"),
      TradeType.EXACT_INPUT
    );
    this.setState({
      tokenToEth: trade.executionPrice.invert().toSignificant(6),
      ethToToken: trade.executionPrice.toSignificant(6),
    });

  }

  async _updateBalance() {
    const balance = await this._token.balanceOf(this.state.selectedAddress);
    const earned = await this._token.earned(this.state.selectedAddress);
    const rewards = await this._token.rewards(this.state.selectedAddress);
    const rewardsLP = await this._farming.earned(this.state.selectedAddress);
    const lpDeposited = await this._farming.balanceOf(
      this.state.selectedAddress
    );
    const lpTokenBalance = await this._lpToken.balanceOf(
      this.state.selectedAddress
    );
    const isEligible = await this._token.isEligible(this.state.selectedAddress);
    const rewardPerToken = await this._token.rewardPerToken();
    const rewardRate = await this._staking.rewardRate();
    const rewardPerTokenStored = await this._token.rewardPerTokenStored();
    const userRewardPerTokenPaid = await this._token.userRewardPerTokenPaid(this.state.selectedAddress);

    const earnedLP = rewardsLP;
    const rewards2 = await this._farming.rewards(this.state.selectedAddress);
    const stakedQTE = await this._staking.balanceOf(this.state.selectedAddress);
    const stakingRewards = await this._staking.earned(this.state.selectedAddress);

    this.setState({
      balance,
      rewards,
      earned,
      rewardsLP,
      lpTokenBalance,
      lpDeposited,
      isEligible,
      rewardPerToken,
      rewardRate,
      rewardPerTokenStored,
      userRewardPerTokenPaid,
      lpRewardsEarned: rewards2,
      stakedQTE,
      stakingRewards

    });
  }

  // This method sends an ethereum transaction to transfer tokens.
  // While this action is specific to this application, it illustrates how to
  // send a transaction.
  async _transferTokens(to, amount) {
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.

    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      const tx = await this._token.transfer(to, amount);
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }

  // This method sends an ethereum transaction to transfer tokens.
  // While this action is specific to this application, it illustrates how to
  // send a transaction.
  async _claimReward() {
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.

    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      const tx = await this._staking.getReward();
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  async _claimRewardLP() {
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.

    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      const tx = await this._farming.getReward();
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  async _approveToken(address, balance) {
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      // const tx = await approve(lpContract, farmContract, account)
      const tx = await this._lpToken.approve(
        contractAddress.Staking,
        ethers.constants.MaxInt256
      );
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      this.setState({ approved: true });
      // if (this.state.lpDeposited === 0) {
      //   $("#farming__content3").css("display", "none");
      // } else {
      //   $("#farming__content3").css("display", "block");
      // }
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  async _approveQTEforStaking() {
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      // const tx = await approve(lpContract, farmContract, account)
      const tx = await this._token.approve(
        contractAddress.Staking2,
        ethers.constants.MaxInt256
      );
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      this.setState({ approvedQTEforStaking: true });
      // this._approveWETHforProxy();
      // if (this.state.lpDeposited === 0) {
      //   $("#farming__content3").css("display", "none");
      // } else {
      //   $("#farming__content3").css("display", "block");
      // }
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  // Step 1: Approve QTE for use by Proxy Contract
  async _approveQTEforProxy() {
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      // const tx = await approve(lpContract, farmContract, account)
      const tx = await this._token.approve(
        contractAddress.Proxy,
        ethers.constants.MaxInt256
      );
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      this.setState({ approvedQTEforProxy: true });
      // this._approveWETHforProxy();
      // if (this.state.lpDeposited === 0) {
      //   $("#farming__content3").css("display", "none");
      // } else {
      //   $("#farming__content3").css("display", "block");
      // }
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }

  // Step 2: Approve WETH for use by Proxy Contract
  async _approveWETHforProxy() {
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      // const tx = await approve(lpContract, farmContract, account)
      const tx = await this._weth.approve(
        contractAddress.Proxy,
        ethers.constants.MaxInt256
      );
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      this.setState({ approvedWETHforProxy: true });
      // if (this.state.lpDeposited === 0) {
      //   $("#farming__content3").css("display", "none");
      // } else {
      //   $("#farming__content3").css("display", "block");
      // }
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }

  async _addLiquidity(amountA, amountB) {
    // We first initialize ethers by creating a provider using window.ethereum
    // this._provider = new ethers.providers.Web3Provider(window.ethereum);
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.
    //reformat amount to wei
    // const amountWei = ethers.utils.parseEther(amount);
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      const tx = await this._proxy.addLiquidity(amountA, amountB);

      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.

      this.setState({ liqAdded: true });
      clearInterval(this._pollDataInterval2);
      this._pollDataInterval2 = undefined;
      await this._updateBalance();
      // this._approveToken();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  async _depositQTEToken(amount) {
    // this function is for staking QTE tokens
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.
    //reformat amount to wei
    // const amountWei = ethers.utils.parseEther(amount);
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      console.log(amount);
      const tx = await this._staking.stake(amount);

      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  async _withdrawQTEToken(amount) {
    // unstake QTE tokens
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.
    //reformat amount to wei
    // const amountWei = ethers.utils.parseEther(amount);
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      const tx = await this._staking.withdraw(amount);
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }

  async _depositToken(amount) {
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.
    //reformat amount to wei
    // const amountWei = ethers.utils.parseEther(amount);
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      console.log(amount);
      const tx = await this._farming.stake(amount);

      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  async _withdrawToken(amount) {
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.
    //reformat amount to wei
    // const amountWei = ethers.utils.parseEther(amount);
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      const tx = await this._farming.withdraw(amount);
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }
  // This method sends an ethereum transaction to stake tokens.
  // This uses the staking contract and not the token contract.
  async _farmToken(amount) {
    // Sending a transaction is a complex operation:
    //   - The user can reject it
    //   - It can fail before reaching the ethereum network (i.e. if the user
    //     doesn't have ETH for paying for the tx's gas)
    //   - It has to be mined, so it isn't immediately confirmed.
    //     Note that some testing networks, like Hardhat Network, do mine
    //     transactions immediately, but your dapp should be prepared for
    //     other networks.
    //   - It can fail once mined.
    //
    // This method handles all of those things, so keep reading to learn how to
    // do it.
    console.log("farmToken", amount);
    try {
      // If a transaction fails, we save that error in the component's state.
      // We only save one such error, so before sending a second transaction, we
      // clear it.
      this._dismissTransactionError();

      // We send the transaction, and save its hash in the Dapp's state. This
      // way we can indicate that we are waiting for it to be mined.
      const tx = await this._farming.stake(amount);
      this.setState({ txBeingSent: tx.hash });

      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();

      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw this generic one.
        throw new Error("Transaction failed");
      }

      // If we got here, the transaction was successful, so you may want to
      // update your state. Here, we update the user's balance.
      await this._updateBalance();
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      if (error.code === ERROR_CODE_TX_REJECTED_BY_USER) {
        return;
      }

      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      console.error(error);
      this.setState({ transactionError: error });
    } finally {
      // If we leave the try/catch, we aren't sending a tx anymore, so we clear
      // this part of the state.
      this.setState({ txBeingSent: undefined });
    }
  }

  // This method just clears part of the state.
  _dismissTransactionError() {
    this.setState({ transactionError: undefined });
  }

  // This method just clears part of the state.
  _dismissNetworkError() {
    this.setState({ networkError: undefined });
  }

  // This is an utility method that turns an RPC error into a human readable
  // message.
  _getRpcErrorMessage(error) {
    if (error.data) {
      return error.data.message;
    }

    return error.message;
  }

  // This method resets the state
  _resetState() {
    this.setState(this.initialState);
  }

  // This method checks if Metamask selected network is Localhost:8545
  _checkNetwork() {
    if (window.ethereum.networkVersion === HARDHAT_NETWORK_ID) {
      return true;
    }

    this.setState({
      networkError: "Please connect Metamask to correct network",
    });

    return false;
  }
}
export default Dapp;
